@defer {
<div class="base-layout">
  <app-header class="desktop-header"></app-header>

  <!-- Main content area -->
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</div>
}
@loading {
<div *ngIf="isLoading" class="spinner-wrapper">
  <div class="spinner">Loading...</div>
</div>
}
